export namespace Constants {

    export const APP_VERSION = "0.1";

    // TESTING 
    export const API_DEV                    = 1;
    export const API_PROD                   = 2;

    export const CLEAR_STORAGE              = false;    // true = clear storage on each load.

    //export const DEV_URL                    = "http://localhost/cat_api/cwis/index.php/api/";
    export const DEV_URL                    = "https://www.clientassetmanager.com/cat_api/cwis/index.php/api/";
    export const PROD_URL                   = "https://www.clientassetmanager.com/cat_api/cwis/index.php/api/";

    export const TOAST_SUCCESS              = 1;
    export const TOAST_ERROR                = 2;
    export const TOAST_INFO                 = 3;

    export const USERROLE_STAFF = 3;


    export const JOB_TYPE_HEIC_PPM = 1;
    export const JOB_TYPE_HEIC_REACTIVE = 2;

    export const APP_TYPE_PORTAL = 1;
    export const APP_TYPE_APP = 2;


    // STORAGE KEYS
    export const kStorage = 'catstorage';
    export const kUser = 'user';
    export const kCurDev = "kDevice";
    export const kCurDevUuid = "kCurDevUuid";
    export const kSesId = "kSesId";
    export const kEnvMode = "kEm";
    export const kAppTheme = "hAt";
    export const kClient = "kCt"
    export const kOrg = "kOrg"
    export const kPasswordReset = "kPrs"
    export const kClients = "kCts"
    export const kColVis = "kColV";
    export const kLastAssF = "kLaF";
    export const kLastObs = "kLOb";
    export const kSelRow = "kSelRow";
    export const kStatsFilter = "kStatsFilter";
    export const kPgCount = "kPgCount";
    export const kPgLnth = "kPgLnth";
}